<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="intel-container">
    <h1>News</h1>
    <div class="intel-sections">
      <span>Navigate to: </span>
      <a
        href="#"
        @click.prevent="jumpToInfo('newFeatures')"
      >
        New Features
      </a>
      <a
        href="#"
        @click.prevent="jumpToInfo('indexingChanges')"
      >
        Indexing Changes
      </a>
      <a
        href="#"
        @click.prevent="jumpToInfo('environmentUpdates')"
      >
        Threat Environment Updates
      </a>
      <p class="email-notifications">
        If you require more information, or have information you would like to be shared in the News section, please <a href="/en/contact">contact us</a>
      </p>
    </div>
    <div>
      <div
        ref="newFeatures"
        class="intel-section"
      >
        <a
          href="#"
          @click.prevent="featuresHTML.length > 0 ? openInfo('newFeatures') : {}"
        >
          New Features
        </a>
        <span
          v-if="showNewIcon.newFeatures"
          class="new-icon"
        >
          New updates
        </span>
        <div
          ref="newFeaturesSection"
          class="intel-info"
          :class="{'open': intelSections.newFeatures}"
        >
          <div>
            <select
              v-model="newFeatUpdate"
              class="time-select"
            >
              <option
                v-for="(option, index) in featuresHTML"
                :key="index"
                :value="option[0]"
              >
                {{ optionTitle(option[0]) }}
              </option>
            </select>
            <div
              v-for="(div, index) in featuresHTML"
              :key="index"
            >
              <div
                v-if="newFeatUpdate === div[0]"
                class="intel-month"
                v-html="div[1]"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        ref="indexingChanges"
        class="intel-section"
      >
        <a
          href="#"
          @click.prevent="changesHTML.length > 0 ? openInfo('indexingChanges') : {}"
        >
          Indexing Changes
        </a>
        <span
          v-if="showNewIcon.indexingChanges"
          class="new-icon"
        >
          New updates
        </span>
        <div
          ref="indexingChangesSection"
          class="intel-info"
          :class="{'open': intelSections.indexingChanges}"
        >
          <select
            v-model="newIndexUpdate"
            class="time-select"
          >
            <option
              v-for="(option, index) in changesHTML"
              :key="index"
              :value="option[0]"
            >
              {{ optionTitle(option[0]) }}
            </option>
          </select>
          <div
            v-for="(div, index) in changesHTML"
            :key="index"
          >
            <div
              v-if="newIndexUpdate === div[0]"
              class="intel-month"
              v-html="div[1]"
            />
          </div>
        </div>
      </div>
      <div
        ref="environmentUpdates"
        class="intel-section"
      >
        <a
          href="#"
          @click.prevent="threatHTML.length > 0 ? openInfo('environmentUpdates') : {}"
        >
          Threat Environment Updates
        </a>
        <span
          v-if="showNewIcon.environmentUpdates"
          class="new-icon"
        >
          New updates
        </span>
        <div
          ref="environmentUpdatesSection"
          class="intel-info"
          :class="{'open': intelSections.environmentUpdates}"
        >
          <select
            v-model="newEnvUpdate"
            class="time-select"
          >
            <option
              v-for="(option, index) in threatHTML"
              :key="index"
              :value="option[0]"
            >
              {{ optionTitle(option[0]) }}
            </option>
          </select>
          <div
            v-for="(div, index) in threatHTML"
            :key="index"
          >
            <div
              v-if="newEnvUpdate === div[0]"
              class="intel-month"
              v-html="div[1]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'IntelOverview',
  data() {
    return {
      openNewFeatures: false,
      intelSections: {
        newFeatures: false,
        indexingChanges: false,
        environmentUpdates: false
      },
      lastUpdate: {
        newFeatures: '',
        indexingChanges: '',
        environmentUpdates: ''
      },
      showNewIcon: {
        newFeatures: false,
        indexingChanges: false,
        environmentUpdates: false
      },
      newFeatUpdate: null,
      newIndexUpdate: null,
      newEnvUpdate: null,
      threatHTML: null,
      featuresHTML: null,
      changesHTML: null,
      months: {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December'
      }
    }
  },
  mounted() {
    this.lastUpdate.newFeatures = new Date('September 29, 2026').getTime()
    this.lastUpdate.indexingChanges = new Date('November 4, 2026').getTime()
    this.lastUpdate.environmentUpdates = new Date('November 4, 2026').getTime()

    if (!Cookies.get('last-visit')) {
      let date = new Date()
      Cookies.set('last-visit', date.setDate(date.getDate()))
      for (let key in this.lastUpdate) {
        this.showNewIcon[key] = true
      }
    } else {
      let lastVisit = Cookies.get('last-visit')
      for (let key in this.lastUpdate) {
        var lastVisitDate = new Date(parseInt(lastVisit))
        var lastVisitTime = new Date((lastVisitDate.getMonth() + 1) + '/' + lastVisitDate.getDate() + '/' + lastVisitDate.getFullYear()).getTime()
        if (this.lastUpdate[key] >= lastVisitTime) this.showNewIcon[key] = true
      }
      let date = new Date()
      Cookies.set('last-visit', date.setDate(date.getDate()))
    }
    axios.get('/en/load-newshub').then(response => {
      this.threatHTML = this.reorderYears(this.reorderMonths(response.data.threat))
      this.featuresHTML = this.reorderYears(this.reorderMonths(response.data.features))
      this.changesHTML = this.reorderYears(this.reorderMonths(response.data.changes))
      if (this.featuresHTML.length > 0) this.newFeatUpdate = this.featuresHTML[0][0]
      if (this.changesHTML.length > 0) this.newIndexUpdate = this.changesHTML[0][0]
      if (this.threatHTML.length > 0) this.newEnvUpdate = this.threatHTML[0][0]
    })
  },
  methods: {
    openInfo(target) {
      this.intelSections[target] = this.intelSections[target] !== true
      if (this.showNewIcon[target] === true) {
        this.showNewIcon[target] = false
      }
    },
    jumpToInfo(target) {
      if (this.intelSections[target] === false) {
        this.$refs[target + 'Section'].ontransitionend = () => {
          this.$refs[target].scrollIntoView({behavior: 'smooth'})
        }
        this.openInfo(target)
      } else {
        this.$refs[target].scrollIntoView({behavior: 'smooth'})
      }
    },
    optionTitle(text) {
      let yearMonth = text.split(' ')
      return this.months[yearMonth[1]] + ' ' + yearMonth[0]
    },
    reorderMonths(months) {
      return months.sort((a, b) => {
        return b[0].split(' ')[1] - a[0].split(' ')[1]
      })
    },
    reorderYears(years) {
      return years.sort((a, b) => {
        return b[0].split(' ')[1] - a[0].split(' ')[1]
      })
    }
  }
}
</script>

<style>
.intel-container {
  width: 100%;
}
.intel-sections {
  margin-bottom: 30px;
  position: relative;
}
.intel-sections a {
  text-align: center;
  margin-left: 20px;
  display: inline-block;
}
.intel-section {
  border: 2px solid hsl(11, 3%, 80%);
  margin-bottom: 30px;
  position: relative;
}
.intel-section > a {
  display: block;
  padding: 20px;
  background: hsl(11, 3%, 95%);
  text-decoration: none;
}
.intel-info {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
.intel-info.open {
  height: auto;
  max-height: 2000px;
  transition: max-height 0.3s ease-in;
  overflow-y: scroll;
}
.intel-month h1 {
  font-size: calc(1em + 1.1 * ((100vw - 500px) / (1000 - 500)));
  margin-left: 40px;
  margin-top: 20px;
}
.intel-month h1:first-of-type:after {
  content: 'Latest update';
  background: #a42334;
  color: #fff;
  padding: 3px 5px;
  border-radius: 5px;
  font-weight: normal;
  font-size: 14px;
  position: relative;
  left: 20px;
}
.intel-month > ul {
  margin-top: 20px;
  width: 90%;
}
.intel-month > ul li {
  margin-top: 16px;
}
.intel-month li > p {
  margin-bottom: 4px;
}
.intel-month > p {
  margin-left: 40px;
  width: 90%;
}
.new-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 14px;
  background: #a42334;
  color: #fff;
  padding: 3px 5px;
  border-radius: 5px;
}
.email-notifications {
  font-size: 14px;
  width: 300px;
  text-align: right;
  padding-bottom: 10px;
  position: absolute;
  right: 0;
  top: -15px;
}
.email-notifications a {
  margin-left: 0;
}
.time-select {
  width: 200px;
  margin: 10px 30px;
  text-transform: capitalize;
}
.time-select option {
  text-transform: capitalize;
}
.update-date {
  font-weight: bold;
  margin-left: 40px;
  margin-top: 20px;
}
.update-header {
  font-weight: bold;
  margin-left: 40px;
}
.intel-month p {
  margin-left: 40px;
}
.update-date.latest-update:first-of-type:after {
  content: 'Latest update';
  background: #a42334;
  color: #fff;
  padding: 3px 5px;
  border-radius: 5px;
  font-weight: normal;
  font-size: 14px;
  position: relative;
  left: 20px;
}
</style>
